//TODO: fix any in this file when fixing the normal history views
export const isRefundPossible = (order: any) => {
  const orderHasBeenCompleted = order?.status === 'COMPLETED';
  const orderHasBeenRefunded = order?.status === 'REFUNDED';
  const thereAreItemsToRefund = order?.items.some((item: any) => !item.isRefunded);
  const thereIsATipToRefund = order?.payment.correctedTip && order?.payment.correctedTip > 0;

  return (
    (orderHasBeenCompleted && thereAreItemsToRefund) ||
    ((orderHasBeenCompleted || orderHasBeenRefunded) && thereIsATipToRefund)
  );
};
